module.exports = __webpack_public_path__ + "img/A09-19720228-001.744f6791.jpg";